import type { RouteRecordRaw } from 'vue-router'
import { Layout, getParentLayout } from '@/utils/routerHelper'

const adminFinanceRoutes: RouteRecordRaw[] = [
  {
    path: '/finance',
    name: 'Finance',
    component: Layout,
    meta: {
      title: '财务管理',
      icon: 'mdi-wallet-outline',
      alwaysShow: true
    },
    children: [
      {
        path: 'member',
        name: 'FinanceMember',
        component: getParentLayout(),
        meta: { title: '代理提现', icon: 'mdi-credit-card-outline', alwaysShow: true },
        children: [
          {
            path: 'card',
            name: 'FinanceMemberCard',
            component: () => import('@/views/Admin/Finance/Member/CardList.vue'),
            meta: {
              title: '银行卡'
            }
          },
          {
            path: 'qrcode',
            name: 'FinanceMemberQrcode',
            component: () => import('@/views/Admin/Finance/Member/QrcodeList.vue'),
            meta: {
              title: '收款二维码'
            }
          },
          {
            path: 'withdraw',
            name: 'FinanceMemberWithdraw',
            component: () => import('@/views/Admin/Finance/Member/Withdraw.vue'),
            meta: {
              title: '提现列表'
            }
          }
        ]
      }
    ]
  }
]

export default adminFinanceRoutes
